module.exports = __webpack_public_path__ + "eg.8e3bb120a2c76f520804.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/eg.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/eg.svg
// module chunks = styles